import { useState } from "react";
import "./PublicCollectionsHeader.css";
import { apiRequestPublicCollection } from "../../services/PublicCollectionService";
import toast, { Toaster } from "react-hot-toast";
import { toastSuccess } from "../../config";
import { ModalRequestCollection } from "./ModalRequestCollection";

type PublicCollectionsHeaderProps = {
    title?: string;
}

export const PublicCollectionsHeader = ({title} : PublicCollectionsHeaderProps) => {

    const [showRequestModal, setShowRequestModal] = useState(false);

    const handleRequest = async (url: string) => {
        await apiRequestPublicCollection(url);
        toast("Request submitted. Thank you!", toastSuccess);
    }

    return (
        <div className="public-collections-header">
            <div 
                className="public-collections-header-logo"
                onClick={() => {
                    window.open("https://usewinslow.com", "_blank");
                }}
            >
                <img src="/winslow_large.png" alt="public collections" />
            </div>
            <div className="public-collections-header-title">
                {title ? title : "Public Collections"}
            </div>
            <div className="public-collections-header-right">
                <button
                    onClick={() => {
                        setShowRequestModal(true);
                    }}
                >
                   Request a Collection
                </button>
                <button
                    onClick={() => {
                        window.open("https://meetings.hubspot.com/niel-robertson/winslow-team?uuid=e196a867-1e1e-411a-9874-d1ea6c69e65e", "_blank");    
                    }}
                >
                   Talk to Sales
                </button>
            </div>

            {showRequestModal &&
                <ModalRequestCollection 
                    isOpen={showRequestModal}
                    onClose={()=> setShowRequestModal(false)}
                    onSubmit={handleRequest}
                />
            }
            <Toaster />
        </div>

    )
}